// handles all video buttons which have the attribute data-vimeo-url-a
import Player from '@vimeo/player';
import lightboxInit from './lightbox';
import { vimeoIdFromUrl } from './helpers';

const $ = window.jQuery;
const { open, changeHTML, events } = lightboxInit();
const $vimeoButtons = $('[data-vimeo-url-a]');

// Don't like ua sniffing but
//http://stackoverflow.com/questions/9038625/detect-if-device-is-ios
const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

if ($vimeoButtons.length !== 0) {
	changeHTML(`<div id="vimeo-player"></div>`);
	let player = false;
	let id;
	let videoIDLoaded = false;

	$vimeoButtons.on('click', function() {
		const date = Date.now();
		id = new Date(date).getTime();
		const $this = $(this);
		const vimeoUrl = $this.attr('data-vimeo-url-a');
		const vimeoID = vimeoIdFromUrl(vimeoUrl);
		let isLightboxOpen = false;
		const videoLoaded = () => {
			if (isLightboxOpen === true) {
				if (!iOS) player.play();
			}
			else isLightboxOpen = () => {
				if (!iOS) player.play();
			};
		};
		if (player === false) {
			videoIDLoaded = vimeoID;
			player = new Player('vimeo-player', { id: vimeoID });
		}
		else {
			if (videoIDLoaded === vimeoID) {
				player.setCurrentTime(0);
			} else {
				videoIDLoaded = vimeoID;
				player.loadVideo(vimeoID).catch((err) => console.log(err));
			}

		}

		player.on('loaded', videoLoaded);

		open();

		events.once('OPEN', () => {
			if (id !== date) return;
			if (typeof isLightboxOpen === 'function') isLightboxOpen();
			else isLightboxOpen = true;
		});

		events.once('OPEN_ERROR', () => {
			player.off('loaded', videoLoaded);
		});

		events.once('CLOSED', () => {
			player.pause();
			player.off('loaded', videoLoaded);
		});

	});
}
